/**
 * Persistenca izbranega TTS glasu (localStorage, per-brskalnik).
 * Strežniški default je DEFAULT_VOICE_ID; neveljavna shranjena vrednost
 * se na strežniku tiho degradira (resolveVoice), zato tu ne validiramo.
 */
import { DEFAULT_VOICE_ID } from './voices';

const STORAGE_KEY = 'tribonianus-voice-id';

export function getSelectedVoiceId(): string {
  if (typeof window === 'undefined') return DEFAULT_VOICE_ID;
  try {
    return window.localStorage.getItem(STORAGE_KEY) || DEFAULT_VOICE_ID;
  } catch {
    return DEFAULT_VOICE_ID;
  }
}

export function setSelectedVoiceId(id: string): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // localStorage poln/blokiran — izbira velja le za sejo
  }
}
